<template>
  <div style="position:relative;">
    <div class="content">
      <div class="contentBox">
        <div class="leftBanner hidden-list">
          <div class="treeBox">
            <p class="title">{{ $t('productList.product_type') }}</p>
            <div class="tree">
              <el-collapse accordion v-model='activeNum' @change="handleChange">
                <el-collapse-item v-for='(item, idx) in $store.state.productTypeList' :key='idx' :name='item.id'>
                  <template slot='title'>
                    <p class="title_1">{{ item.categoryName }}</p>
                  </template>
                  <My-Check v-for='(items, index) in item.subCategoryList' :key='index'
                    :checked="isCheckedSubCategory(items.id)" :dataItem="items" v-on:checkedData="handleClickCheckbox">
                  </My-Check>
                  <Check-All key="all_products" v-on:checkedAllData="checkedAllData" :categoryId="item.id" />
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div class="checkBox">
            <p class="title">{{ $t('productList.screen') }}</p>
            <div class="checkbox">
              <div>
                <ul v-for='(item, idx) in $store.state.filterList' :key="idx" :name='item.id'>
                  <li slot='title'>
                    <p class="title_2">{{ item.categoryName }}</p>
                  </li>
                  <My-Check v-for='(items, idxs) in item.subCategoryList' :key="idxs" :checked="isCheckedFilter(items.id)"
                    :dataItem="items" v-on:checkedData="checkedFData"></My-Check>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="rightBanner" style="width:1070px;">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyCheck from '@/components/MyCheck'
import CheckAll from '@/components/CheckAll'
export default {
  name: 'ProductList',
  computed: {
    isCheckedSubCategory() {
      return function (id) {
        return this.$store.state.subCategoryId.includes(id)
      }
    },
    isCheckedFilter() {
      return function (id) {
        return this.$store.state.otherId.includes(id)
      }
    },
    activeNum: {
      get() {
        return `${this.$store.state.activeNum}`
      },
      set(v) {
        this.$store.commit("handleChange", v)
      }
    }
  },
  components: {
    MyCheck,
    CheckAll
  },
  distoryed() {
    this.$store.commit('showPermit', false);
    this.$store.commit('getThisData', {});
  },
  created: function () {
  },
  mounted: function (){
    this.reportVisitor()
  },
  methods: {
    reportVisitor() {
      this.$store.dispatch('reportVisitor', { recordType: 1 })
    },
    handleClickCheckbox(data) {
      this.$store.commit('clearCheckedAllCategoryId')
      this.checkedData(data)
    },
    //点击选择框
    checkedData(data) {
      this.$store.commit('addSubCategoryId', data.id);
      if (this.$store.state.checkedAllCategoryId || this.$store.state.subCategoryId.length > 0 || this.$store.state.otherId.length > 0 || this.$store.state.search['checked']) {
        this.$router.push({
          name: 'ProductFPage',
          query: {
            subCategoryIds: this.$store.state.subCategoryId.length === 0 ? undefined : this.$store.state.subCategoryId,
            search: this.$store.state.search['history'] == "" ? undefined : this.$store.state.search['history'],
            otherId: this.$store.state.otherId.length === 0 ? undefined : this.$store.state.otherId,
            categoryId: this.$store.state.activeNum == "" ? undefined : this.$store.state.activeNum,
          }
        })
        this.$store.dispatch('getProductDataList')
      } else {
        var id = this.$store.state.activeNum
        this.$store.dispatch('getHotProductList');
        this.$router.push({ name: 'ProductSPage', params: { cname: id } })
      }
    },
    checkedAllData(checked) {
      if (checked) {
        // this.$store.commit('changeFilterIdCheckedState', false);
        // this.$store.commit('changeCheckedState', false);
        this.$store.commit('clearSubcategoryId', true);
        this.$store.commit('changePageIndex', 1)
        // this.$store.commit('clearOtherId', true)
        this.checkedData({})
      } else {
        this.checkedData({})
      }
    },
    checkedFData(data) {
      this.$store.commit('addOtherId', data.id);
      if (this.$store.state.subCategoryId.length > 0 || this.$store.state.otherId.length > 0 || this.$store.state.search['checked']) {
        if (data.checked) {
          this.$store.dispatch('getProductDataList');
        } else {
          this.$store.dispatch('getProductDataList')
        }
        this.$router.push({
          name: 'ProductFPage',
          query: {
            subCategoryIds: this.$store.state.subCategoryId.length === 0 ? undefined : this.$store.state.subCategoryId,
            search: this.$store.state.search['history'] == "" ? undefined : this.$store.state.search['history'],
            otherId: this.$store.state.otherId.length === 0 ? undefined : this.$store.state.otherId,
            categoryId: this.$store.state.activeNum == "" ? undefined : this.$store.state.activeNum,
          }
        })

      } else {
        if (this.$store.state.activeNum !== '') {
          var id = this.$store.state.activeNum
          this.$store.dispatch('getHotProductList');
          this.$router.push({ name: 'ProductSPage', params: { cname: id } })
        } else {
          this.$router.push({ name: 'ProductIndex' })
        }
      }
    },
    //展开折叠面板或者合并折叠面板
    handleChange(val) {
      this.$store.commit('clearCheckedAllCategoryId')
      this.$store.commit('clearOtherId', true);
      this.$store.commit('changeFilterIdCheckedState', false);
      // this.$store.commit('changeCheckedState', false);
      this.$store.commit('clearSubcategoryId', true);
      this.$store.commit('changePageIndex', 1)

      if (this.$store.state.subCategoryId.length > 0 || this.$store.state.otherId.length > 0
        || this.$store.state.search['checked']) {
        this.$router.push({
          name: 'ProductFPage',
          query: {
            subCategoryIds: this.$store.state.subCategoryId.length === 0 ? undefined : this.$store.state.subCategoryId,
            search: this.$store.state.search['history'] == "" ? undefined : this.$store.state.search['history'],
            otherId: this.$store.state.otherId.length === 0 ? undefined : this.$store.state.otherId,
            categoryId: this.$store.state.activeNum == "" ? undefined : this.$store.state.activeNum,
          }
        });
        this.$store.dispatch('getProductDataList')
      } else {
        if (val != "") {
          this.$router.push({
            name: 'ProductSPage',
            params: {
              cname: val
            }
          })
          this.$store.dispatch('getHotProductList');
        } else {
          this.$router.push({
            name: 'ProductIndex',
          });
        }
      }

    },
  }
}
</script>

<style lang="scss" scoped src='../../assets/css/ProductList.scss'></style>
